module.exports = __webpack_public_path__ + "static/media/close-envelope.71973b7a.svg";